import { render } from "./componentsWeights.vue?vue&type=template&id=51cf300c&scoped=true&ts=true"
import script from "./componentsWeights.vue?vue&type=script&lang=ts"
export * from "./componentsWeights.vue?vue&type=script&lang=ts"

import "./componentsWeights.vue?vue&type=style&index=0&id=51cf300c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51cf300c"]])

export default __exports__